import React from "react";
import { KTSVG } from '../../../../_metronic/helpers';

interface TranscriptionInfoCardProps {
    title: string;
    total: number;
    path: string;
}

export const TranscriptionInfoCard: React.FC<TranscriptionInfoCardProps> = ({ title, total, path }) => {
    return (
        <div className='col-12 col-lg-6 col-xl-3'>
            <div className='card card-xl-stretch mb-xl-8'>
                <div className='card-body'>
                    <div className='d-flex align-items-center'>
                        <div className='flex-grow-1'>
                            <div className='fw-semibold fs-3 text-muted'>{title}</div>
                            <div className='text-black fw-bold fs-2 mb-2 mt-5'>{total}</div>
                        </div>
                        <KTSVG
                            path={path}
                            className='svg-icon-3x svg-icon-success d-block my-2'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};